import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { BaseInputComponent } from '../base-input/base-input.component';
import { MatInput } from '@angular/material/input';
import { QuestionStateService } from '../question-state.service';
import { DateTimeInputType } from '../form.types';

@Component({
    selector: 'app-date-time-picker',
    templateUrl: './date-time-picker.component.html',
    styleUrls: ['./date-time-picker.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class DateTimePickerComponent extends BaseInputComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() override input: DateTimeInputType;
    @ViewChild(MatInput) inputElement: MatInput;
    constructor(private questionStateService: QuestionStateService, private changeDetection: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        super.initialize(this.input, this.questionStateService);
    }

    ngAfterViewInit() {
        if (this.inputElement) {
            this.inputIdEvent.emit(this.inputElement.id);
        }
        this.changeDetection.detectChanges();
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
    }
}
